(() => {
  'use strict';
  const form = document.querySelector('#kb-form');
  if (!form) return;
  const rows = [...form.querySelectorAll('[data-color]')];
  const submit = form.querySelector('[data-checkout]');
  const status = form.querySelector('[data-status]');
  const money = n => '¥' + Math.round(n / 100).toLocaleString('ja-JP');
  const endpoint = '/products/' + encodeURIComponent('真空保存容器-空蔵-kura-7-5kg-コピー') + '.js';
  let ready = false, busy = false;
  const track = (event, data = {}) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event, lp_variant:'B', ...data}); };
  const qty = row => Math.min(99, Math.max(0, Math.floor(Number(row.querySelector('input').value) || 0)));
  function selection() { return rows.map(row => ({row, quantity:qty(row), variant:row.kuraVariant})).filter(item => item.quantity > 0); }
  function render() {
    const items = selection();
    const count = items.reduce((n,x)=>n+x.quantity,0);
    const rate = 0;
    const original = items.reduce((n,x)=>n+x.quantity*(x.variant?.price || 2980000),0);
    const total = original * (100-rate)/100;
    form.querySelector('[data-count]').textContent = '合計' + count + '台';
    form.querySelector('[data-rate]').textContent = count ? (rate ? rate+'%OFF' : '通常価格') : '数量を選択';
    form.querySelector('[data-original]').textContent = money(original);
    form.querySelector('[data-total]').textContent = money(total);
    form.querySelector('[data-saving]').textContent = count && rate ? money(original-total)+'お得' : '';
    rows.forEach(row => {
      const input = row.querySelector('input');
      input.disabled = busy || !ready;
      row.querySelector('[data-step="-1"]').disabled = input.disabled || qty(row) === 0;
      row.querySelector('[data-step="1"]').disabled = input.disabled || !row.kuraVariant?.available || qty(row) >= 99;
    });
    submit.disabled = busy || !ready || !count || items.some(x=>!x.variant?.available);
    return {items,count,rate,total};
  }
  async function refresh() {
    const response = await fetch(endpoint, {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('商品情報を確認できませんでした。ページを再読み込みしてください。');
    const product = await response.json();
    if (product.id !== 8095547818086 || product.currency && product.currency !== 'JPY') throw new Error('商品情報を確認できませんでした。');
    rows.forEach(row => {
      const variant = product.variants.find(v=>v.title === row.dataset.color);
      row.kuraVariant = variant;
      row.querySelector('[data-stock]').textContent = variant?.available ? '10kg' : '売り切れ';
    });
    ready = true;
  }
  rows.forEach(row => {
    row.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click',()=>{
      row.querySelector('input').value = Math.max(0,Math.min(99,qty(row)+Number(button.dataset.step)));
      status.textContent = ''; const data=render(); track('kura_b_quantity_change',{quantity:data.count});
    }));
    row.querySelector('input').addEventListener('change',()=>{row.querySelector('input').value=qty(row);status.textContent='';render();});
  });
  form.addEventListener('submit', async event => {
    event.preventDefault(); if(busy || submit.disabled) return;
    busy=true; render(); status.textContent='購入手続きに進んでいます…';
    try {
      const before=render(); await refresh(); const data=render();
      if(data.items.some(x=>!x.variant?.available)) throw new Error('選択した色が売り切れになりました。数量を変更してください。');
      if(data.total!==before.total) throw new Error('価格が更新されました。合計金額を確認し、もう一度お進みください。');
      const cart = data.items.map(x=>x.variant.id+':'+x.quantity).join(',');
      const params = new URLSearchParams();
      params.set('attributes[lp_variant]','B');
      track('kura_b_begin_checkout',{quantity:data.count,value:data.total/100,currency:'JPY',discount_percent:data.rate});
      location.assign('/cart/'+cart+'?'+params.toString());
    } catch(error) { status.textContent=error.message; busy=false;render(); }
  });
  window.addEventListener('pageshow',()=>{busy=false;render();});
  const sticky = document.querySelector('.kb-sticky');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(document.querySelector('#purchase'));
  }
  render();
  refresh().then(()=>{status.textContent='';render();track('kura_b_view');}).catch(error=>{status.textContent=error.message;render();});
})();
